import React from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from 'react-highcharts';
import Highcharts from 'highcharts';

const LineChart = ({ data, seriesName, isFontSizeBig }) => {
  const series = [{
    name: seriesName,
    data,
    animation: false,
    color: '#0c7cd5',
  }];
  const config = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      animation: {
        duration: 1000,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        month: '%b %Y',
      },
      crosshair: true,
      labels: {
        style: {
          fontSize: isFontSizeBig ? '16px' : null,
        },
      },
    },
    tooltip: {
      formatter: function () {
        let s = `<span style="font-weight: bold; ${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}">${Highcharts.dateFormat('%b %Y', this.x)}</span>
                 <table class="table table-condensed" style="${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}; margin-top:1em; margin-bottom: 0;">`;
        this.points.forEach(function (point) {
          s += `<tr>
                    <td style="color:${point.series.color};">${point.series.name}:&nbsp;</td>
                    <td class="text-right" style="color:${point.series.color};"><b>${point.y}</b></td>
                  </tr>`;
        });
        return s + '</table>';
      },
      headerFormat: `<span style="font-weight: bold; ${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}">{point.key}</span>
        <table class="table table-condensed" style="${isFontSizeBig ? 'font-size:16px' : 'font-size:12px'}; margin-top:1em; margin-bottom: 0;">`,
      pointFormat: `<tr>
        <td style="color:{series.color};">{series.name}:&nbsp;</td>
        <td class="text-right"><b>{point.formatedY}</b></td>
      </tr>`,
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      backgroundColor: 'rgba(0,0,0, 0.75)',
      borderColor: 'rgba(0,0,0, 0.95)',
      style: {
        color: 'rgba(255, 255, 255, 0.75)',
      },
    },
    legend: {
      itemStyle: {
        fontSize: isFontSizeBig ? '16px' : null,
      },
    },
    yAxis: [
      {
        title: {
          text: null,
          style: {
            fontSize: isFontSizeBig ? '16px' : null,
            fontWeight: 'bold',
          },
        },
        labels: {
          style: {
            fontSize: isFontSizeBig ? '16px' : null,
          },
        },
        alternateGridColor: 'rgba(66,66,66,0.05)',
        lineWidth: 0,
        plotLines: [{
          value: 0,
          dashStyle: 'dashed',
          color: 'rgba(0, 0, 0, 0.5)',
          width: 2,
          label: {
            text: null,
          },
        }],
      }
    ],
    plotOptions: {
      series: {
        stacking: 'normal',
        marker: {
          fillColor: '#ffffff',
          lineWidth: 2,
          radius: 5,
          lineColor: null, // inherit from series
        },
      },
    },
    series,
  };

  return (
    <ReactHighcharts config={config} />
  );
};

LineChart.propTypes = {
  data: PropTypes.array.isRequired,
  seriesName: PropTypes.string.isRequired,
  isFontSizeBig: PropTypes.bool
};

export default LineChart;
